export default "__VITE_ASSET__ba43f783__"